
const digest = '78d80ba0227d423ef58872e5943ff7b6ba3b262e42dc0c5018740723136145af';
const classes = {"wrapper":"_wrapper_heyph_1","title":"_title_heyph_7","text":"_text_heyph_10"};
const css = `._wrapper_heyph_1 {
  display: flex;
  flex-direction: row;
  gap: 5px;
  font-size: 14px;
}
._wrapper_heyph_1 ._title_heyph_7 {
  color: grey;
}
._wrapper_heyph_1 ._text_heyph_10 {
  color: #000000;
  white-space: pre-line;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  